<!-- Navigation -->

@if (isScreenMedium$$()) {
  <fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="'over'"
    [name]="'mainNavigation'"
    [navigation]="core.navigationItems$$()"
    [opened]="false">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <!-- Logo -->
      <div class="flex h-20 items-center justify-center">
        <img class="w-8" src="assets/images/logo/logo.svg" alt="Logo image" />
      </div>
    </ng-container>
  </fuse-vertical-navigation>
}

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div
    class="flex-0 z-49 bg-card relative flex h-16 w-full items-center px-4 shadow sm:h-20 md:px-6 dark:border-b dark:bg-transparent dark:shadow-none print:hidden">
    @if (!isScreenMedium$$()) {
      <!-- Logo -->
      <div class="mx-2 flex items-center">
        <img class="w-8" src="assets/images/logo/logo.svg" />
      </div>
      <!-- Horizontal navigation -->
      <fuse-horizontal-navigation
        class="mr-2"
        [name]="'mainNavigation'"
        [navigation]="navigation.horizontal" />
    }
    <!-- Navigation toggle button -->
    @if (isScreenMedium$$()) {
      <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
        <mat-icon [svgIcon]="'heroicons_outline:bars-3'" />
      </button>
    }
    <!-- Components -->
    <div class="ml-auto flex items-center space-x-2 pl-2">
      <app-expert-manager-event-notification />
      @if (core.currentExpertManager$$()) {
        <app-color-scheme-menu-button
          [webColorScheme]="core.currentExpertManager$$().webColorScheme"
          (bySetWebColorScheme)="setWebColorScheme($event)" />
      }
      <user />
    </div>
  </div>

  <!-- Content -->
  <div class="flex w-full flex-auto flex-col">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
    Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet />
    }
  </div>
</div>
